import React, {Fragment, useState} from 'react'
import {Spin} from 'antd'
import TableHead from './data/TableHead'
import TableRow from './data/TableRow'
import emptyData from '../../../assets/images/empty-img-gray.png'
import ListBrandsPagination from "./ListBrandsPagination";

const ListBrandsTable = (props) => {
    const {loading, brandLists} = props
    const [loadingSend, _setLoadingSend] = useState(false)

    return (
        <div className="ShippingRuleTable">
            <Spin spinning={loading} tip='Loading...'>
                {brandLists.length > 0 ? (
                    <div>
                        <table className='table'>
                            <TableHead/>
                            <tbody className="TableBody">
                            {
                                brandLists.map(brand => {
                                    return (
                                        <Fragment key={brand._id}>
                                            <TableRow
                                                loadingSend={loadingSend}
                                                handleSendLoading={_setLoadingSend}
                                                brand={brand}
                                                currentPage={1}
                                            />
                                        </Fragment>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        <ListBrandsPagination {...props}/>
                    </div>
                ) : !loading && (
                    <div className="noData d-flex flex-column align-items-center justify-content-center">
                        <img src={emptyData} alt="No data"/>
                        No data!
                    </div>
                )}
            </Spin>
        </div>
    )
}

export default ListBrandsTable
